import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import confetti from "canvas-confetti";

/**
 * Hook para renderizar confetes na tela
 * - Só renderiza quando a URL for "/dashboard/ranking"
 * - Funciona tanto para autenticado quanto não autenticado
 * @param durationMs - Duração da animação em milissegundos (padrão: 1200ms)
 */
export function useConfetti(durationMs: number = 1200) {
  const location = useLocation();

  useEffect(() => {
    // Efeito de confetes - SOMENTE na URL "/dashboard/ranking"
    if (location.pathname !== "/dashboard/ranking") {
      return;
    }

    const end = Date.now() + durationMs;
    const colors = ["#FFD700", "#FFA500", "#C0C0C0", "#CD7F32"];
    let animationFrameId: number | null = null;

    const frame = () => {
      confetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors,
      });
      confetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors,
      });

      if (Date.now() < end) {
        animationFrameId = requestAnimationFrame(frame);
      }
    };

    animationFrameId = requestAnimationFrame(frame);

    // Cleanup: cancela a animação e limpa todos os confetes quando o componente for desmontado ou a rota mudar
    return () => {
      if (animationFrameId !== null) {
        cancelAnimationFrame(animationFrameId);
      }
      // Remove todos os confetes da tela imediatamente
      confetti.reset();
    };
  }, [location.pathname, durationMs]);
}
